var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0013 2.16602C7.0213 2.16602 2.16797 7.01935 2.16797 12.9993C2.16797 18.9793 7.0213 23.8327 13.0013 23.8327C18.9813 23.8327 23.8346 18.9793 23.8346 12.9993C23.8346 7.01935 18.9813 2.16602 13.0013 2.16602ZM13.0013 21.666C8.2238 21.666 4.33464 17.7768 4.33464 12.9993C4.33464 8.22185 8.2238 4.33268 13.0013 4.33268C17.7788 4.33268 21.668 8.22185 21.668 12.9993C21.668 17.7768 17.7788 21.666 13.0013 21.666ZM13.9655 12.0244C12.0371 11.3852 11.1055 10.9843 11.1055 9.96602C11.1055 8.86102 12.308 8.46018 13.0663 8.46018C14.4855 8.46018 15.0055 9.53268 15.1246 9.91185L16.8363 9.18602C16.6738 8.70935 15.948 7.11685 13.9546 6.77018V5.41602H12.0588V6.78102C9.24214 7.38768 9.22047 9.86852 9.22047 9.98768C9.22047 12.4468 11.658 13.1402 12.8496 13.5735C14.5613 14.1802 15.3196 14.7327 15.3196 15.7727C15.3196 16.9969 14.1821 17.5168 13.1746 17.5168C11.203 17.5168 10.6396 15.491 10.5746 15.2527L8.7763 15.9785C9.4588 18.351 11.2463 18.9902 12.048 19.1852V20.5827H13.9438V19.2393C14.5071 19.1418 17.2155 18.6002 17.2155 15.751C17.2263 14.2452 16.5655 12.9235 13.9655 12.0244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.f7414079e134e6bcb24cb22eb37151be.svg";
export { ForwardRef as ReactComponent };